import { ParametroPaginacionGenerico } from "src/app/util/ParametroPaginacionGenerico";

export class FiltroCoCobranza {

    numerocobranza: string;
    fechaco: Date;
    fechavenc: Date;
    estado: string;
    clientenum: number;
    vendedor: string;
    nombreCliente: string;
    usuarioActualCompania: string;
    constructor() {
        this.paginacion = new ParametroPaginacionGenerico();
        this.paginacion.atributoOrdenar = "co.FechaPreparacion";
        this.paginacion.direccionOrdenAtributo = 1;
    }
    paginacion: ParametroPaginacionGenerico;
}
